import { Routes } from '@angular/router';
import { NotebookListComponent } from './pages/notebook-list.component';

import { NotebookCreateFormComponent } from './pages/notebook-create-form.component';
import { NotebookDetailsComponent } from './pages/notebook-details.component';
import { ConsumptionComponent } from './pages/consumption.component';
import { PageNotFoundComponent } from './components/utility-components/page-not-found/page-not-found.component';
import { HomeComponent } from './pages/home.component';

export const routes: Routes = [
    {
      path: '',
      component: HomeComponent,
      title: 'About Quantum Service'
    },
    {
      path: 'list',
      component: NotebookListComponent,
      title: 'Quantum Emulator List'
    },
    {
        path: 'consumption',
        component: ConsumptionComponent,
        title: 'My Consumption'
    },
    {
        path: 'new',
        component: NotebookCreateFormComponent,
        title: 'Create a Quantum Emulator'
    },
    {
        path: 'details/:id',
        component: NotebookDetailsComponent,
        title: 'Quantum Emulator details'
      },
    { path: '**', component: PageNotFoundComponent },
      
];
